import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from '../../../shared/services/common.service';
import { API_ENDPOINTS } from '../../../core/services/api.service';
import { environment } from '../../../../environments/environment';

/**
 * Service to handle feature management operations
 */
@Injectable({
    providedIn: 'root'
})
export class FeatureManagementService {
    private readonly apiBaseUrl = environment.apiBaseUrl;
    private readonly endpoints = API_ENDPOINTS.MASTER_MANAGEMENT.FEATURES;

    constructor(private commonService: CommonService) { }

    /**
     * Get all features
     * @param applicationIds Optional array of application IDs to filter by (1 for storage, 2 for transport)
     * If not provided, returns all features without filtering
     */
    getAllFeatures(applicationIds?: number[]): Observable<any> {
        let url = `${this.apiBaseUrl}${this.endpoints.GET}`;
        if (applicationIds && applicationIds.length > 0) {
            const params = applicationIds.map(id => `application_id=${id}`).join('&');
            url += `?${params}`;
        }

        return this.commonService.httpSvc.get(url);
    }

    /**
     * Add a new feature
     */
    addFeature(featureData: { name: string; description: string; application_id?: number[] }): Observable<any> {
        return this.commonService.httpSvc.post(
            `${this.apiBaseUrl}${this.endpoints.ADD}`,
            featureData
        );
    }
}

